import React from 'react'
import './PopupOneButton.scss'

export const PopupOneButton = (props) => {
    const { title, text, textButton, onClick } = props

    const handleClick = () => {
        onClick()
    }

    return (
        <div className="popup-one-button-container">
            <div className="content">
                <div className="title">
                    <p>{title}</p>
                </div>
                <div className="text">
                    <p>{text}</p>
                </div>
                <div className="botton">
                    <button className="btn" onClick={handleClick}>{textButton}</button>
                </div>
            </div>
        </div>
    )
}
